import React, { useState, useEffect } from 'react';
import { Card, CardContent } from '../../components/ui/card';
import { ChevronRight, Loader2 } from 'lucide-react';
import { getDegreeWork } from '../../services/api';
import { Alert, AlertDescription } from '../../components/ui/alert';

const DegreeWorkPage = () => {
  const [degreeWork, setDegreeWork] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDegreeWork = async () => {
      try {
        const response = await getDegreeWork();
        setDegreeWork(response.data.degreeWork || []);
      } catch (err) {
        console.error('Failed to fetch degree work:', err);
        setError('Failed to load degree work materials. Please try again later.');
      } finally {
        setLoading(false);
      }
    };
    fetchDegreeWork();
  }, []);

  if (loading) {
    return (
      <div className="p-6 md:p-12 flex items-center justify-center min-h-[400px]">
        <Loader2 className="h-8 w-8 animate-spin text-emerald-600" />
      </div>
    );
  }

  return (
    <div className="p-6 md:p-12 lg:p-16" data-testid="degree-work-page">
      <div className="max-w-4xl">
        <h1 className="font-heading text-4xl md:text-5xl font-bold text-gray-900 mb-6">
          Degree Work
        </h1>

        <p className="text-lg text-gray-700 leading-relaxed mb-8">
          The ritual work of the Lodge is organized into the following degrees and ceremonials.
          Use the sections below to access full ritual materials and study guides.
        </p>

        {error && (
          <Alert variant="destructive" className="mb-6">
            <AlertDescription>{error}</AlertDescription>
          </Alert>
        )}

        {/* Degree List */}
        <section className="mb-10" data-testid="degree-list">
          <h2 className="font-heading text-2xl font-semibold text-gray-900 mb-4">
            Ritual Materials
          </h2>
          <div className="space-y-4">
            {degreeWork.length === 0 && !error && (
              <p className="text-gray-500 italic">No ritual materials available at this time.</p>
            )}
            {degreeWork.map((degree) => (
              <Card
                key={degree.id}
                className="border-gray-100 hover:shadow-md transition-shadow cursor-pointer"
                data-testid={`degree-item-${degree.id}`}
                onClick={() => {
                  if (degree.url) window.open(degree.url, '_blank');
                }}
              >
                <CardContent className="p-4 flex items-center justify-between">
                  <div>
                    <h3 className="font-medium text-gray-900">{degree.title}</h3>
                    <p className="text-sm text-gray-500">{degree.description}</p>
                  </div>
                  <ChevronRight className="h-5 w-5 text-gray-400" />
                </CardContent>
              </Card>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default DegreeWorkPage;
